import { render, staticRenderFns } from "./ConvertedResultsTable.vue?vue&type=template&id=477497fa"
import script from "./ConvertedResultsTable.vue?vue&type=script&lang=js"
export * from "./ConvertedResultsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports